import React, { useState, useEffect } from 'react';
import api from '../services/api';

const HealthCheck = () => {
  const [healthStatus, setHealthStatus] = useState({
    isLoading: true,
    isHealthy: false,
    error: null,
    details: null
  });

  useEffect(() => {
    const checkBackendHealth = async () => {
      try {
        const response = await api.get('/healthcheck');
        setHealthStatus({
          isLoading: false,
          isHealthy: response.data.status === 'healthy',
          error: null,
          details: response.data
        });
      } catch (error) {
        setHealthStatus({
          isLoading: false,
          isHealthy: false,
          error: error.message || 'Failed to connect to backend',
          details: {
            status: 'unhealthy',
            error: error.message,
            code: error.response?.status || 'NETWORK_ERROR'
          }
        });
      }
    };

    checkBackendHealth();
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-md mx-auto bg-white rounded-lg shadow-md overflow-hidden">
        <div className="p-6">
          <h1 className="text-2xl font-bold mb-4">Backend Health Status</h1>
          
          {healthStatus.isLoading ? (
            <div className="flex items-center justify-center py-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
              <span className="ml-2">Checking backend health...</span>
            </div>
          ) : healthStatus.isHealthy ? (
            <div className="bg-green-100 border-l-4 border-green-500 p-4 mb-4">
              <div className="flex items-center">
                <svg className="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <p className="text-green-700 font-medium">Backend is healthy</p>
              </div>
            </div>
          ) : (
            <div className="bg-red-100 border-l-4 border-red-500 p-4 mb-4">
              <div className="flex items-center">
                <svg className="h-6 w-6 text-red-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
                <p className="text-red-700 font-medium">Backend is unhealthy</p>
              </div>
              {healthStatus.error && (
                <p className="text-red-600 mt-2">{healthStatus.error}</p>
              )}
            </div>
          )}

          {healthStatus.details && !healthStatus.isLoading && (
            <div className="mt-4">
              <h2 className="text-lg font-semibold mb-2">Response Details:</h2>
              <pre className="bg-gray-100 p-4 rounded overflow-x-auto text-sm">
                {JSON.stringify(healthStatus.details, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HealthCheck;
